export default {
  all: 'Alla',
}
